import React from 'react';
import { Tag } from 'antd';
import type { ClientType } from 'api/swagger';

interface IClientTypeProps {
  type?: ClientType;
  isVip?: boolean;
  isShort?: boolean;
  className?: string;
}

export const ClientTypeTag: React.FC<IClientTypeProps> = (props) => {
  const { type, isVip, className, isShort = false } = props;
  const color = isVip ? 'success' : 'default';

  const getText = () => {
    const typeText = isShort ? type?.substring(0, 3) : type;

    if (isVip) return `VIP ${typeText}`;

    return typeText;
  };

  return (
    <Tag color={color} className={className}>
      {getText()}
    </Tag>
  );
};
